export default __webpack_public_path__ + "static/media/Image.32e7d557.png";